module.exports = __webpack_public_path__ + "static/media/main.d02d45a0.styl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/main.styl
// module id = 125
// module chunks = 0